// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"542de398","459":"97d4b22b","706":"a6383329"}[chunkId] + ".css";
};